<template>
    <div>
        <el-row style="margin-top: 2vh;padding: 20px;">


            <el-col :span="24">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="项目类型">
                        <el-select v-model="value" clearable placeholder="项目类型" style="margin-left: 20px;"
                            @change="onSubmit">
                            <el-option v-for="item in options" :key="item.value" :label="item.value
                                " :value="item.value">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item>


                        <el-button type="primary" @click="increase()">新增/修改</el-button>
                    </el-form-item>

                </el-form>
            </el-col>
            <el-col :span=24>

                <div class="grid-content bg-purple-light">


                    <img :src="examples" alt="">
                    <!-- <img src="https://ts1.tc.mm.bing.net/th/id/R-C.6f18e58bf3bacbcee226cb76dfc089a3?rik=61%2bMLnhOzFiZOg&riu=http%3a%2f%2fimages.shejidaren.com%2fwp-content%2fuploads%2f2014%2f07%2f085628m6c.jpg&ehk=v1vDvzVgPRc3irw6n%2bs5gF%2b5SEc1uCstErDhRaxqlgE%3d&risl=&pid=ImgRaw&r=0"
                        alt=""> -->
                </div>
            </el-col>
            <!-- 新增 -->
            <div v-if="isEdit"
                style="height: 100vh;background:rgba(0, 0, 0, 0.5); width: 100%;left: 0;position: fixed;top: 0;z-index: 999;">
                <div class="edit">
                    <div class="edit_title">
                        <p>添加封面图片</p>
                        <p @click="cancellation()">X</p>
                    </div>
                    <div>
                        <el-form v-loading="loading" :model="ruleForm" ref="ruleForm" label-width="100px"
                            class="demo-ruleForm">


                            <el-form-item label="项目类型" prop="exType
">
                                <!-- <el-input style="width: 75%;" v-model="ruleForm.exType
                                    "></el-input> -->
                                <el-select v-model="ruleForm.exType" filterable clearable placeholder="请输入案例类型">
                                    <el-option v-for="item in options" :key="item.value" :label="item.value
                                        " :value="item.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="封面图片" prop="dishImgUrl" style="width: 30%;">
                                <el-button type="primary" @click="uploadImage">封面图片</el-button>
                                <div v-if="dishImgUrl" style="color: #000;"> <img
                                        style="width: 150px;height: 150px;margin-top: 10px;" :src="dishImgUrl"
                                        alt="封面图片" />
                                </div>
                            </el-form-item>



                            <el-form-item style="margin-left: 80px;">
                                <el-button type="primary" @click="added()"
                                    v-loading.fullscreen.lock="fullscreenLoading">确认</el-button>
                                <el-button @click="cancellation()">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </el-row>
    </div>
</template>
<script>

import { updateTrainCover, findTrainCover } from "@/api/cover";


export default {

    data() {
        return {

            file3: [],
            options: [
                {
                    value: '厨房设计',
                    label: '厨房设计'
                }, {
                    value: '智慧厨房',
                    label: '智慧厨房'
                }, {
                    value: '厨房标识',
                    label: '厨房标识'
                }, {
                    value: '厨房瓷砖',
                    label: '厨房瓷砖'
                }, {
                    value: '厨房新砖',
                    label: '厨房新砖'
                }, {
                    value: '厨房新风',
                    label: '厨房新风'
                }
                , {
                    value: '垃圾处理',
                    label: '垃圾处理'
                }
                , {
                    value: '厨房洗消',
                    label: '厨房洗消'
                }
                , {
                    value: '自助餐台',
                    label: '自助餐台'
                }
                , {
                    value: '厨房净水',
                    label: '厨房净水'
                }
                , {
                    value: '厨房排水',
                    label: '厨房排水'
                }
                , {
                    value: '培训一',
                    label: '培训一'
                }
                , {
                    value: '培训二',
                    label: '培训二'
                },
                {
                    value: '培训三',
                    label: '培训三'
                }

            ],
            currentPage: 1, // 当前页码
            pageNum: 1,
            pageSize: 10,
            // 总条数
            total: 0,

            isEdit: false,


            dishImgUrl: "",
            dishImgUrl2: "",
            multipleImagesUrls: [], // 存储多张图片的相关信息（这里假设存储图片URL，可按需调整）
            formInline: {
                exName: ''
            },

            editForm: {}, // 用于存储当前编辑的行数据
            examples: [{
                exName: "",//厨具名称
                fType: 'Training'

            }],
            ruleForm: {
                exName: "",//厨具名称
                fType: 'Training'
            },
            value: '',

            value1: '', file: '', file2: '', videoFile: '', videoName: '',
            fullscreenLoading: false
        }

    },
    mounted() {
        findTrainCover({ tType: '厨房设计' }).then(response => {
            console.log(response);
            this.examples = response

        })
    },
    methods: {

        tableRowClassName({ rowIndex }) {
            if (rowIndex % 2 !== 0) {
                return 'warning-row';
            }
            return '';
        },
        // 请求列表
        onSubmit(selectedValue) {
            findTrainCover({ tType: selectedValue }).then(response => {
                console.log(response);
                this.examples = response

            })
        },
        handleSizeChange(val) {
            this.currentPage = 1;
            this.pageSize = val;
            // this.printSelectedDates()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            // this.printSelectedDates()
        },



        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },

        cancellation() {
            this.isEdit = false;
            this.ruleForm = {
                exName: "",//厨具名称
                fType: 'Training'
            }
            this.dishImgUrl2 = ''
            this.dishImgUrl = ""
            this.multipleImagesUrls = []
        },
        // 确定上传
        added() {


            const formData = new FormData();
            formData.append("tType", this.ruleForm.exType)
            formData.append("newImg ", this.file)
            updateTrainCover(formData).then(response => {
                const data = response
                console.log(data);
                this.$message({
                    message: response,
                    type: 'success'
                });
                this.fullscreenLoading = false

                this.isEdit = false
                findTrainCover({ tType: this.ruleForm.exType }).then(response => {
                    console.log(response);
                    this.examples = response + '?t=' + Date.now()
                    this.total = response.length
                })

                this.ruleForm = {
                    exType: "",//厨具名称
                }

            }).catch((error) => {
                if (error.response && error.response.status === 400) {
                    this.$message({
                        message: '有必填选项未填',
                        type: 'error'
                    });
                } else {
                    console.error('请求出错:', error);
                    this.$message({
                        message: '网络错误',
                        type: 'error'
                    });

                }
            });
        },

        increase() {
            this.isEdit = true
        },




        // 上传
        uploadImage() {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg'; // 修改为只接受jpg格式，这里对应MIME类型是image/jpeg
            input.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                    const fileName = file.name;
                    const fileExtension = fileName.split('.').pop().toLowerCase();
                    if (fileExtension === 'jpg' || fileExtension === 'jpeg') {
                        const reader = new FileReader();
                        reader.onload = () => {
                            const formData = new FormData();
                            formData.append('image1', file);
                            console.log(file);
                            // 假设this是某个对象实例，这里的赋值按实际需求调整
                            this.file = file;
                            this.ruleForm.coImg1 = reader.result;

                            formData.append('pageId', 'lunbo');
                            this.dishImgUrl = reader.result; // 打印图片的DataURL
                            console.log(formData);
                        };
                        reader.readAsDataURL(file);
                    } else {
                        alert('请上传jpg格式的图片');
                    }
                }
            });
            input.click();
        },


    }

}
</script>
<style lang="scss" scoped>
/* .el-menu {
    height: 94vh;
  } */
.table-header {
    background-color: rgb(230, 242, 255) !important;


}




.el-table .warning-row {
    background: rgb(230, 242, 255);
}

.el-menu-vertical-demo {
    height: 94vh;
}

.red {
    color: red;
}

.block {

    margin: 20px 0 20px 12%;

}

.grid-content {
    width: 100%;
    height: 72vh;

    img {
        width: 96%;
        height: 72vh;
    }
}

.edit {
    width: 600px;
    height: 700px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    cursor: pointer;
    overflow: auto;

    .edit_title {
        display: flex;
        justify-content: space-between;
        background-color: rgb(51, 119, 255);
        color: #fff;
        height: 40px;
        align-items: center;
        padding: 0 20px;
    }

    .demo-ruleForm {
        margin-top: 20px;
        padding: 0 20px;
    }


}
</style>